import { HttpParams } from "@angular/common/http";
import { Component, OnInit, TemplateRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { AdminService } from "src/app/services/admin.service";
import { apiUrl } from "../../../global/global";
import * as CONSTANT from "../../../services/constants"
import swal from "sweetalert2";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-suggested-job",
  templateUrl: "./suggested-job.component.html",
  styleUrls: ["./suggested-job.component.css"]
})
export class SuggestedJobComponent implements OnInit {
  jobId;
  allData: any;
  listingData: any = [];
  currentPage = 1;
  pagination = { limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: "" }
  // sorting
  sortType: any;
  sortBy: string = ""
  orderBy: string = "2";
  search = "";
  closeSearch: boolean = false;
  jobForm: FormGroup;
  showError: boolean = false;
  //modal box
  modalRef?: BsModalRef;
  config = {
    backdrop: true,
    ignoreBackdropClick: false
  };
  viewCount: any;
  page;
  constructor(private modalService: BsModalService, public route: ActivatedRoute, private router: Router, private api: AdminService, private formBuilder: FormBuilder, private toastrService: ToastrService) {

    this.jobForm = this.formBuilder.group({
      id: [""],
      reason: ["", Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(2000)])],
      isBlocked: [""],
      isNotify: [""]
    })
  }

  ngOnInit(): void {
    this.jobId = this.route.snapshot.paramMap.get("id");
    this.route.queryParams.subscribe(params => {
      this.page = params['page'];
    });
    this.getData();
    this.getDetail();
  }

  backToJob() {
    this.router.navigate(['jobs'], { queryParams: { page: this.page } })
  }
  // detail
  getDetail() {
    this.api.getDatas(apiUrl._getJobs + "/" + this.jobId)
      .subscribe(async (res) => {
        this.allData = res.data

      })
  }
  getData() {
    let params = new HttpParams();
    params = params.append("jobPostId", this.jobId);
    params = params.append("skip", this.currentPage);
    params = params.append("limit", this.pagination.limit.toString());
    if (this.search != null && this.search != "") {
      params = params.append("search", this.search);
    }
    if (this.sortBy) {
      params = params.append(
        "sortBy",
        this.sortBy.trim() ? this.sortBy.trim() : ""
      );
      params = params.append("orderBy", this.orderBy == "ASC" ? "ASC" : "DESC");
    }
    this.api.getData(apiUrl._getSuggested, params)
      .subscribe(async (res) => {
        this.pagination.totalItems = res.data.count;
        this.viewCount = res.data.totalViewCount;
        this.listingData = res.data.listing;
      })
  }
  pageChanged(event: any): void {
    if (event == this.currentPage) return;
    this.currentPage = event;
    this.pagination.skip = (event - 1) * this.pagination.limit;
    window.scroll(0, 0);
    this.getData();
  }
  searchFun() {
    this.currentPage = 1;
    this.pagination.skip = 0;
    this.closeSearch = true;
    if (this.listingData.length > 0) {
      this.getData();
    }
  }
  clearSearch() {
    this.search = "";
    this.closeSearch = false;
    this.pagination.skip = 0;
    localStorage.removeItem("type-redirect");
    // if (this.listingData.length > 0) {
      this.getData();
    // }
  }
  redirectToApplicant() {
    // this.router.navigateByUrl(`/jobs/applicant/${this.jobId}`);
    this.router.navigate(['/jobs/applicant/' + this.jobId], { queryParams: { page: this.page } })
  }
  redirectToDetail() {
    // this.router.navigateByUrl(`/jobs/detail/${this.jobId}`);
    this.router.navigate(['/jobs/detail/' + this.jobId], { queryParams: { page: this.page } })
  }
  redirectTo(data) {
    if (this.viewCount > 0) {
      this.router.navigate([`/jobs/suggested/${this.jobId}/appdetail/`], { queryParams: { userId: `${data.id}`, applicantId: data.id } });
    } else {
      this.toastrService.error("", "Your profile view count is 0 to see more applicant profile you need to buy the new plan.");
    }
  }
  // status
  jobOpenStatus(event, id) {
    let text = "<p>Are you sure you want to Open this job?</p>";
    swal.fire({
      html: text,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      width: 500
    }).then((result) => {
      if (result.value) {
        const data = {
          "id": id,
          "isBlocked": 0,
        }
        this.api.putData(apiUrl._getJobs, data).subscribe(res => {
          this.getDetail();
        })
      }
    });
  }
  // job status
  openModal(allData, jobStatus: TemplateRef<any>) {
    this.jobForm.reset()
    this.jobForm.patchValue({
      id: allData?.JobPost?.id,
      isBlocked: 1,
    })
    this.modalRef = this.modalService.show(
      jobStatus,
      Object.assign({}, this.config, { class: "modal-sm addModal" })
    );
  }
  // job status
  jobPostStatus() {
    if (this.jobForm.valid) {
      if (this.jobForm.value.isNotify == true) {
        this.jobForm.patchValue({
          isNotify: 1
        })
      } else {
        this.jobForm.patchValue({
          isNotify: 0
        })
      }
      this.api.putData(apiUrl._statusReason, this.jobForm.value).subscribe(res => {
        this.modalRef?.hide()
        this.modalService.hide()
        this.jobForm.reset()
        this.getData();
        this.getDetail();
      })
    } else {
      this.showError = true
      setTimeout(() => {
        this.showError = false
      }, 1500);
    }
  }
  // shortlisted
  shortListed(event, id) {
    let block;
    let text = "<p>Are you sure you want to Shortlist this user?</p>";
    swal.fire({
      html: text,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      width: 500
    }).then((result) => {
      if (result.value) {
        const data = {
          "userId": id,
          "jobPostId": this.jobId,
        }
        this.api.postData(apiUrl._getSortListed, data).subscribe(res => {
          this.getData();
        })
      }
    });
  }
  hideListed(event, id) {
    let text = "<p>Are you sure you want to hide this user?</p>";
    swal.fire({
      html: text,
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
      width: 500
    }).then((result) => {
      if (result.value) {
        const data = {
          "userId": id,
          "jobPostId": this.jobId,
          "isType": 0,
        }
        this.api.postData(apiUrl._getHide, data).subscribe(res => {
          this.getData();
        })
      }
    });
  }
}

